function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import ReactPlayer from 'react-player';
import React from 'react';
import PropTypes from 'prop-types';
import isValidUrl from 'is-url';
import isValidHTML from 'is-html';
import classnames from 'classnames';
import { getPlayerCss } from "./utils/getPlayerCss";
import { getReactPlayerProps } from "./utils/getReactPlayerProps";
import { logWarning } from "./utils/logWarning";
export var Component = function Component(_ref) {
  var height = _ref.height,
      isResponsive = _ref.isResponsive,
      videoSource = _ref.videoSource,
      width = _ref.width;
  var playerWrapperProps = {
    className: classnames('video', 'player-wrapper', {
      'is-url': isValidUrl(videoSource),
      'is-html': isValidHTML(videoSource),
      'is-responsive': isResponsive
    }),
    style: getPlayerCss(isResponsive, width, height)
  };

  switch (true) {
    case isValidUrl(videoSource):
      return React.createElement("div", playerWrapperProps, React.createElement(ReactPlayer, getReactPlayerProps(isResponsive, videoSource)));

    case isValidHTML(videoSource):
      return React.createElement("div", _extends({}, playerWrapperProps, {
        dangerouslySetInnerHTML: {
          __html: videoSource
        }
      }));

    default:
      logWarning(videoSource);
      return null;
  }
};
Component.displayName = 'Video';
Component.defaultProps = {
  height: 315,
  isResponsive: false,
  videoSource: null,
  width: 560
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  height: PropTypes.number,
  isResponsive: PropTypes.bool,
  videoSource: PropTypes.string,
  width: PropTypes.number
} : {};